module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("The Ex I")]), _vm._v(" "), _c('p', {
    staticClass: "BT-Opener"
  }, [_c('span', {
    staticClass: "Drop CharOverride-9"
  }, [_vm._v("H")]), _vm._v("e still loves his ex-girlfriend, and they’re still close friends. She’s elegant and clever. She was at the top of her class in classics in school, they both know Latin, and they’re both well-read; they toss Derrida quotes around like it’s nothing. The other day, he asked me to meet him at a coffeehouse, so it was more than a little strange that he was sitting with her when I arrived. I felt humiliated, and I wanted to leave, to turn around and walk straight out, to disappear, but they’d already spotted me and I had to sit with them. It was one of the most uncomfortable afternoons of my life. I was stressed, sweating like a pig, and I got this weird tremor. They were so relaxed together, and so much smarter than me. They talked about movies I hadn’t seen, and they went on and on about things I hadn’t ever thought about. The Ex tried to bring me into the conversation by explaining, among other things, what a "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("strawberry milkshake")]), _vm._v(" was—it’s when a man cums on a woman’s face and punches her in the nose, giving her a nosebleed. "), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Snowballing")]), _vm._v(","), _c('span', {
    staticClass: "CharOverride-6"
  }), _vm._v("she went on, is when a man cums in a woman’s mouth and she spits it into his mouth. He’s told me about sex with her—how nice it was, how talented she is at blow jobs. I’m pretty bad at them; I just gag. ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43c0b794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802157409-8.vue
// module id = 87
// module chunks = 0